(ns practitest.frontend.components2.dashboard.transforms.table
  (:require [practitest.frontend.components2.dashboard.helpers :as h]))

(defn cell-urls
  [{:chart/keys [item-route x-values-map y-values-map]
    {:keys [columns rows]} :chart/data}]
  (into {}
        (for [[row-idx row] (map-indexed vector rows)
              {:keys [key label]} columns
              :when (not= key :row-label)]
          (let [row-label     (:row-label row)
                is-total-row? (= "TOTAL" row-label)
                is-total-col? (= :total key)
                x-param       (get x-values-map (keyword row-label) row-label)
                y-param       (get y-values-map (keyword label) label)
                url-params    (cond
                                (and is-total-row? is-total-col?)
                                {}
                                is-total-row?
                                {:y-param y-param}
                                is-total-col?
                                {:x-param x-param}
                                :else
                                {:x-param x-param :y-param y-param})]
            [[row-idx key] (h/url-for item-route url-params)]))))

(defn id-cell-urls
  [{:chart/keys [item-route]
    {:keys [rows]} :chart/data}]
  (let [base-url (:uri item-route)]
    (when base-url
      (into {}
            (for [[row-idx row] (map-indexed vector rows)]
              [[row-idx :id] (str base-url "/" (:entity-id row) "/edit")])))))

(defn transform [{:as chart {:keys [table-type]} :chart/data}]
  (case table-type
    "distribution"            (assoc chart :chart/cell-urls (cell-urls chart))
    ("latest" "traceability") (assoc chart :chart/cell-urls (id-cell-urls chart))
    chart))